import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

/**
 * Opens a Stripe Checkout or Customer Portal URL.
 * Web: full-page redirect.
 * Native Cap: denied by default (App Store 3.1.3(f) web-only billing).
 * Pass `{ allowOnNative: true }` only for non-purchase URLs (e.g. Calendly).
 */
export async function redirectToStripe(
  url: string,
  options?: { allowOnNative?: boolean },
): Promise<void> {
  if (typeof window === 'undefined') return;

  if (Capacitor.isNativePlatform() && options?.allowOnNative !== true) {
    return;
  }

  if (Capacitor.isNativePlatform()) {
    let resolveFinished!: () => void;
    const finished = new Promise<void>((resolve) => {
      resolveFinished = resolve;
    });

    const handle = await Browser.addListener('browserFinished', () => {
      resolveFinished();
    });

    try {
      await Browser.open({ url, presentationStyle: 'popover' });
      await finished;
    } finally {
      await handle.remove();
    }
    return;
  }

  window.location.assign(url);
}

/** Close Capacitor Browser if open (e.g. after a Universal Link return). */
export async function closeStripeBrowser(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await Browser.close();
  } catch {
    // No browser sheet open — ignore.
  }
}
